module.exports = __webpack_public_path__ + "img/2c.63329feb.png";